import { DataSource } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Observable, of as observableOf } from 'rxjs';

import { AuthService } from '@app/services/auth.service';
import type { DocumentData, QueryDocumentSnapshot } from 'firebase/firestore';

// TODO: Replace this with your own data model type
export interface RequestApproveItem {
  name: string;
  id: number;
}


export class RequestApproveSet {
  constructor(
    public docId: string,
    public userName: string,
    public targetDate: Date,
    public actualTimeStamps: string[],
    // public data: RequestRecord,
    public changeTimeStamps: Date[],
    public ejectFlags: boolean[],
    public cause: string,
    public docSnapShot: QueryDocumentSnapshot<DocumentData>) { }
}

// TODO: replace this with real data from your application


/**
 * Data source for the RequestApprove view. This class should
 * encapsulate all logic for fetching and manipulating the displayed data
 * (including sorting, pagination, and filtering).
 */
export class RequestApproveDataSource extends DataSource<RequestApproveSet> {
  // data: RequestApproveSet[];

  constructor(
    public auth: AuthService,
    private paginator: MatPaginator,
    private sort: MatSort,
    public data: RequestApproveSet[]) {
    super();


  }

  /**
   * Connect this data source to the table. The table will only update when
   * the returned stream emits new items.
   * @returns A stream of the items to be rendered.
   */
  connect(): Observable<RequestApproveSet[]> {
    // Combine everything that affects the rendered data into one update
    // stream for the data-table to consume.
    // const dataMutations = [
    //   observableOf(this.data),
    //   this.paginator.page,
    //   this.sort.sortChange
    // ];

    // // Set the paginators length
    // this.paginator.length = this.data.length;

    // return merge(...dataMutations).pipe(map(() => {
    //   return this.getPagedData(this.getSortedData([...this.data]));
    // }));
    console.log('table dataSource connect');
    // this.update();
    return observableOf(this.data);
  }

  /**
   *  Called when the table is being destroyed. Use this function, to clean up
   * any open connections or free any held resources that were set up during connect.
   */
  disconnect() { }

  /**
   * Paginate the data (client-side). If you're using server-side pagination,
   * this would be replaced by requesting the appropriate data from the server.
   */
  private getPagedData(data: RequestApproveSet[]) {
    const startIndex = this.paginator.pageIndex * this.paginator.pageSize;
    return data.splice(startIndex, this.paginator.pageSize);
  }

  /**
   * Sort the data (client-side). If you're using server-side sorting,
   * this would be replaced by requesting the appropriate data from the server.
   */
  private getSortedData(data: RequestApproveSet[]) {
    return data;
  }
}
